/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Provision_PercentInputs */

const cs_deals_provision_percent = /** @type {(inputs: Deals_Provision_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provize (%)`)
};

const en_deals_provision_percent = /** @type {(inputs: Deals_Provision_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commission (%)`)
};

/**
* | output |
* | --- |
* | "Commission (%)" |
*
* @param {Deals_Provision_PercentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_provision_percent = /** @type {((inputs?: Deals_Provision_PercentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Provision_PercentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_provision_percent(inputs)
	return cs_deals_provision_percent(inputs)
});